// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__2JTJA","socialLink":"Social_socialLink__Po-PE","socialItem":"Social_socialItem__qb_aO"};